import React from "react";

interface ClockIconProps {
  className?: string;
}

export const ClockIcon = ({ className }: ClockIconProps) => (
  <svg
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M6.64555 0.634766C2.97353 0.634766 0 3.71042 0 7.50007C0 11.2897 2.97353 14.3654 6.64555 14.3654C10.3242 14.3654 13.3044 11.2897 13.3044 7.50007C13.3044 3.71042 10.3242 0.634766 6.64555 0.634766ZM6.6522 12.9923C3.71193 12.9923 1.33044 10.5345 1.33044 7.50007C1.33044 4.46561 3.71193 2.00783 6.6522 2.00783C9.59247 2.00783 11.974 4.46561 11.974 7.50007C11.974 10.5345 9.59247 12.9923 6.6522 12.9923ZM6.98481 4.06742H5.98698V8.1866L9.47939 10.3492L9.9783 9.50474L6.98481 7.6717V4.06742Z" />
  </svg>
);

ClockIcon.defaultProps = {
  className: "",
};
